import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
const ApprovedAnimation = () => {
  const container = useRef(null);
  const papers = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../utils/lottie/moneyAnimation.json"),
    });
    lottie.loadAnimation({
      container: papers.current,
      renderer: "svg",
      loop: false,
      animationData: require("../../utils/lottie/paperAnimation.json"),
    });
  }, []);
  return (
    <div>
      <div
        className="lottieContainer animationFilter"
        ref={container}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
        }}
      >
        <img
          src="/assets/yellowStars.svg"
          alt="stars"
          className={`yellowStars lottieBg`}
        />
        <img
          src="/assets/pinkCircle.svg"
          alt="circle"
          className={`circle lottieBg`}
        />
        <div ref={papers} className="papers" style={{ height: "200px" }}></div>
      </div>
    </div>
  );
};

export default ApprovedAnimation;
